module.exports = __webpack_public_path__ + "img/userCaseNav2.545e7a6e.png";